import PropTypes from 'prop-types';

import { DocumentType } from '../enums/document-type';

export const DocumentTypePropType = PropTypes.oneOf(Object.values(DocumentType).map((docType) => docType.identifier));

/**
 * @typedef {(
 *   'packing-slip'|
 *   'label'|
 *   'return-label'|
 *   'pick-list'|
 *   'batch-pick-list'|
 *   'customs-forms'|
 *   'other-forms'|
 *   'batch-customs-forms'|
 *   undefined |
 *   'batch-packing-slip'|
 *   'batch-labels'|
 *   'order-summary'|
 *   'end-of-day-form'|
 *   'hotkeys-and-barcode'|
 *   'shipment-manifest'|
 *   'batch-shipment-manifest'
 * )} DocumentTypePropType
 */
